import { motion } from "framer-motion";

const MotionPlaceholder = () => (
  <motion.div
    initial={{ opacity: 0, y: 5 }}
    animate={{ opacity: [0.3, 0.6, 0.3], y: 0 }}
    transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
    style={{
      height: 80,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // background:
      //   "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(240,240,240,0.8) 50%, rgba(255,255,255,0) 100%)",
      backgroundSize: "200% 100%",
      borderRadius: 12,
      margin: "2px 0",
      color: "#888",
      fontWeight: 500,
      fontSize: 14,
    }}
  >
    <motion.span
      animate={{ opacity: [0.5, 1, 0.5] }}
      transition={{ duration: 2, repeat: Infinity }}
    >
      Loading…
    </motion.span>
  </motion.div>
);

export default MotionPlaceholder